<template>
    <SOSlotBase
        :container-name="`riwayat-training`"
        :loading="isLoading">
    
        <template v-slot:title-bar>
            <SOTitleBar
                :page-title="'Riwayat Training'"
                :type="'back'"
                @back="back"
            />
        </template>

        <template v-slot:content>
            <div class="container bg-grey p-x-20 p-t-20">
            <p class="text-hist"> Total 2 Training </p>
            <div class="card card-info">
                <div class="card-bodyinf">
                  <div class="d-flex-between">
                    <div class="sub-bodyinf">TFO241287242</div>
                    <div class="d-flex remove-margin">
                      <div class="labelinf remove-margin">Pembayaran Gagal</div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z"
                          fill="#6F7287"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="sub-bodyinftitle">Training Gratis Online</div>
                <div class="countdown">
                  <svg
                    class="custom-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1520_19609)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.00008 1.99996C4.68637 1.99996 2.00008 4.68625 2.00008 7.99996C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 7.99996C14.0001 4.68625 11.3138 1.99996 8.00008 1.99996ZM0.666748 7.99996C0.666748 3.94987 3.94999 0.666626 8.00008 0.666626C12.0502 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.05 0.666748 7.99996ZM7.99999 3.33329C8.36818 3.33329 8.66666 3.63177 8.66666 3.99996V7.58793L10.9648 8.73701C11.2941 8.90166 11.4276 9.30211 11.2629 9.63143C11.0983 9.96075 10.6978 10.0942 10.3685 9.92957L7.70185 8.59624C7.476 8.48331 7.33333 8.25247 7.33333 7.99996V3.99996C7.33333 3.63177 7.6318 3.33329 7.99999 3.33329Z"
                        fill="#808080"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1520_19609">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span class="TimeInf">4 Agustus 2023 13:00</span>
                </div>
            </div>
            <br>
            <div class="card card-info">
                <div class="card-bodyinf">
                  <div class="d-flex-between">
                    <div class="sub-bodyinf">TFO241287242</div>
                    <div class="d-flex remove-margin">
                      <div class="labelinf2 remove-margin">selesai</div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z"
                          fill="#6F7287"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="sub-bodyinftitle">Training Gratis Online</div>
                <div class="countdown">
                  <svg
                    class="custom-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1520_19609)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.00008 1.99996C4.68637 1.99996 2.00008 4.68625 2.00008 7.99996C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 7.99996C14.0001 4.68625 11.3138 1.99996 8.00008 1.99996ZM0.666748 7.99996C0.666748 3.94987 3.94999 0.666626 8.00008 0.666626C12.0502 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.05 0.666748 7.99996ZM7.99999 3.33329C8.36818 3.33329 8.66666 3.63177 8.66666 3.99996V7.58793L10.9648 8.73701C11.2941 8.90166 11.4276 9.30211 11.2629 9.63143C11.0983 9.96075 10.6978 10.0942 10.3685 9.92957L7.70185 8.59624C7.476 8.48331 7.33333 8.25247 7.33333 7.99996V3.99996C7.33333 3.63177 7.6318 3.33329 7.99999 3.33329Z"
                        fill="#808080"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1520_19609">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span class="TimeInf">4 Agustus 2023 13:00</span>
                </div>
            </div>
            <br>
            <div class="card card-info">
                <div class="card-bodyinf">
                  <div class="d-flex-between">
                    <div class="sub-bodyinf">TFO241287242</div>
                    <div class="d-flex remove-margin">
                      <div class="labelinf3 remove-margin">Dibatalkan oleh CS</div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M8.29289 18.7071C7.90237 18.3166 7.90237 17.6834 8.29289 17.2929L13.5858 12L8.29289 6.70711C7.90237 6.31658 7.90237 5.68342 8.29289 5.29289C8.68342 4.90237 9.31658 4.90237 9.70711 5.29289L15.7071 11.2929C16.0976 11.6834 16.0976 12.3166 15.7071 12.7071L9.70711 18.7071C9.31658 19.0976 8.68342 19.0976 8.29289 18.7071Z"
                          fill="#6F7287"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
                
                <div class="sub-bodyinftitle">Training Gratis Online</div>
                <div class="countdown">
                  <svg
                    class="custom-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_1520_19609)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M8.00008 1.99996C4.68637 1.99996 2.00008 4.68625 2.00008 7.99996C2.00008 11.3137 4.68637 14 8.00008 14C11.3138 14 14.0001 11.3137 14.0001 7.99996C14.0001 4.68625 11.3138 1.99996 8.00008 1.99996ZM0.666748 7.99996C0.666748 3.94987 3.94999 0.666626 8.00008 0.666626C12.0502 0.666626 15.3334 3.94987 15.3334 7.99996C15.3334 12.05 12.0502 15.3333 8.00008 15.3333C3.94999 15.3333 0.666748 12.05 0.666748 7.99996ZM7.99999 3.33329C8.36818 3.33329 8.66666 3.63177 8.66666 3.99996V7.58793L10.9648 8.73701C11.2941 8.90166 11.4276 9.30211 11.2629 9.63143C11.0983 9.96075 10.6978 10.0942 10.3685 9.92957L7.70185 8.59624C7.476 8.48331 7.33333 8.25247 7.33333 7.99996V3.99996C7.33333 3.63177 7.6318 3.33329 7.99999 3.33329Z"
                        fill="#808080"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_1520_19609">
                        <rect width="16" height="16" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span class="TimeInf">4 Agustus 2023 13:00</span>
                </div>
            </div>

            </div>
            <div class="background-content"/>
        </template>
    </SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";
export default {
    name: 'RiwayatTraining',
    components: {
        SOSlotBase,
        SOTitleBar
        },

      data() {
        return{
          isLoading: false,

        }
      },
      methods: {
        back () {
                this.$router.go(-1);
            }
      }
    }
</script>

<style scoped>
.belajar-bersama-smartlink .separator {
    width: unset;
}
.d-flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.text-container {
    display: flex;
}

.text-container .epayment-container {
    width: 121px;
}
.text-container .reminder-container {
    width: 71px;
}

.riwayat-training .container{
    padding-bottom: 55%;
}
.card-bodyinf {
  background-color: white;
  padding-right: 10px;
  text-align: start;
}
.card-info {
  display: flex;
  padding: 10px 16px;
  border-radius: 5px;
  border: 1px solid var(--others-grey-grey-800, #ccc);
  background: #fff;
  margin-top:0;
}
.layout-header{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
}
.labelinf {
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 0;
  border-radius: 3px;
  background: var(--others-red-red-970, #FFF1F1);
  color: #6f7287;
  top: 10px;
  left: 10px;
}
.labelinf2 {
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 0;
  border-radius: 3px;
  background: var(--others-green-green-970, #E8FCEE);
  color: #6f7287;
  top: 10px;
  left: 10px;
}
.labelinf3 {
  display: flex;
  padding: 0px 4px;
  align-items: flex-start;
  gap: 10px;
  margin-bottom: 0;
  border-radius: 3px;
  background: var(--others-red-red-490, #DA1E28);
  color: #FFF;
  top: 10px;
  left: 10px;
}
.sub-bodyinftitle {
  color: var(--primary-black, #000);
  font-family: Overpass;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  margin-top: 5px;
  letter-spacing: -0.32px;
}
.TimeInf {
  padding-left: 10px;
  color: var(--secondary-midgrey, #6f7287);
  font-family: Overpass;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; 
  letter-spacing: -0.24px;
}

.text-hist {
    font-family: Overpass;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 24px */
    letter-spacing: -0.32px;
    color: var(--secondary-midgrey, #6F7287);
}
</style>
